import CacheMachine from '@/common/utils/CacheMachine'

const shopDetailGalleryList = {
  title: '',
  pics: [],
}
// 营销付款计算器
const paymentCalculator = {}
const currencyPrecision = 0

const shopBaseDetail = new CacheMachine({})
const currentShopBaseDetail = {}

const bizoppDetail = new CacheMachine({})
const currentBizoppDetail = {}
const currentBizoppBillAccount = {}
const allConfig = new CacheMachine({})
const currentAllConfig = {}

const contractorDetail = new CacheMachine({})
const currentContractorDetail = {}
const saleData = {}

const showDatePick = false
const showPicker = false
const backoutApply = false

const type = ''
const itemOptions = []
const itemOptionTotal = 0
const preSignupList = []
const allSelectItems = []
const specialItemList = []
const currentSelected = 0
const confirmStatus = false
const confirmSelectItems = []

export default {
  shopDetailGalleryList,
  currentShopBaseDetail,
  shopBaseDetail,
  currentBizoppBillAccount,
  contractorDetail,
  currentContractorDetail,
  bizoppDetail,
  currentBizoppDetail,
  showDatePick,
  showPicker,
  backoutApply,
  allConfig,
  paymentCalculator,
  currentAllConfig,
  currencyPrecision,
  saleData,
  type,
  itemOptions,
  itemOptionTotal,
  preSignupList,
  confirmStatus,
  allSelectItems,
  specialItemList,
  currentSelected,
  confirmSelectItems,
}
